var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 50,
    viewBox: "0 0 37 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 17.9078C37 27.798 18.5 50 18.5 50C18.5 50 0 27.798 0 17.9078C0 8.0176 8.28273 0 18.5 0C28.7173 0 37 8.0176 37 17.9078Z",
    fill: "url(#paint0_linear_7158_44385)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 12.0953C19.8394 12.0953 20.9252 11.0547 20.9252 9.77104C20.9252 8.4874 19.8394 7.44681 18.5 7.44681C17.1606 7.44681 16.0748 8.4874 16.0748 9.77104C16.0748 11.0547 17.1606 12.0953 18.5 12.0953ZM27.9313 14.6132C27.9313 13.7931 27.2376 13.1283 26.3819 13.1283H10.618C9.76231 13.1283 9.0686 13.7931 9.0686 14.6132C9.0686 15.4333 9.76231 16.0981 10.618 16.0981H13.3801C14.273 16.0981 14.9969 16.7919 14.9969 17.6476V19.8427V23.4582V24.4912V29.9144C14.9969 30.6276 15.6001 31.2057 16.3442 31.2057C17.0883 31.2057 17.6916 30.6276 17.6916 29.9144V24.4912V23.4582V23.2C17.6916 22.7721 18.0535 22.4252 18.5 22.4252C18.9464 22.4252 19.3084 22.7721 19.3084 23.2V23.4582V24.4912V29.9144C19.3084 30.6276 19.9116 31.2057 20.6557 31.2057C21.3998 31.2057 22.0031 30.6276 22.0031 29.9144V24.4912V23.4582V19.8427V17.6476C22.0031 16.7919 22.7269 16.0981 23.6199 16.0981H26.3819C27.2376 16.0981 27.9313 15.4333 27.9313 14.6132Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7158_44385",
    x1: 18.5,
    y1: 0,
    x2: 18.5,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCD1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF8021"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8a2945b9db2a5ca4e791c875185e644f.svg";
export { ForwardRef as ReactComponent };